<template>
  <div class="wrap">
    <img class="code" :src="url">
  </div>
</template>

<script>
export default {
  data () {
    return {
      url: 'https://sz.bjadks.com/api/v1/home/GetSZQRImage?path=pages/tapbar/course/course?Id=10'
    }
  },
  created () {
    const params = this.$route.query
    // console.log(params)
    if (params.videoId) {
      this.url = `https://sz.bjadks.com/api/v1/home/GetPlayQRImage?path=pages/playvideo/playvideo&CourseId=${params.courseId}&VideoId=${params.videoId}&code=sz`
    }
  }
}
</script>

<style scoped>
  .wrap {
    position: relative;
    max-width: 600px;
    height: 100vh;
    background: url("../assets/img/code_bg.jpg") center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .wrap .code {
    width: 140px;
    height: 140px;
    margin-top: 300px;
  }

  @media screen and (max-height: 500px){
    .wrap .code{
        margin-top: 230px;
        width: 120px;
        height: 120px;
    }
  }

   @media screen and (min-height: 500px) and (max-height: 600px) {
    .wrap .code{
        margin-top: 240px;
        width: 120px;
        height: 120px;
    }
  }

  @media screen and (min-height: 600px) and (max-height: 700px) {
    .wrap .code{
        margin-top: 280px;
        width: 120px;
        height: 120px;
    }
  }

   @media screen and (min-height: 700px) and (max-height: 800px) {
    .wrap .code{
        margin-top: 320px;
        width: 120px;
        height: 120px;
    }
  }
   @media screen and (min-height: 800px) and (max-height: 900px) {
     .wrap .code{
        margin-top: 340px;
        width: 140px;
        height: 140px;
    }
  }

  @media screen and (min-height: 900px) {
    .wrap .code{
        margin-top: 400px;
        width: 140px;
        height: 140px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/play_phone.vue